import { createContext } from 'react';
import type { AuthContextType } from './SuperadminAuthContext';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
